import { Component, OnInit, ViewChild, Optional, Inject, ElementRef, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MapsAPILoader, MouseEvent } from '@agm/core';
import { SignConfirmComponent } from '.././dialogs/sign-confirm/sign-confirm.component';
import { vueMaisonComponent } from '.././dialogs/vue-maison/vue-maison.component';
import { AlertService } from 'projects/hp-api/src/lib/services/alert.service';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';

import { FormGroup, FormBuilder, Validators } from "@angular/forms";
//import {} from "googlemaps";
import html2canvas from 'html2canvas';
import { WizardHpBaseComponent } from '../base/wizard/wizard-hp-base-component';
import { ChangeDetectionStrategy } from '@angular/compiler/src/compiler_facade_interface';
import { Router } from '@angular/router';

interface Location {
  latitude: number;
  longitude: number;
  mapType: string;
}
@Component({
  selector: 'app-street-view-map',
  templateUrl: './street-view-map.component.html',
  styleUrls: ['./street-view-map.component.css']
})
export class StreetViewMapComponent extends WizardHpBaseComponent implements OnInit {
  @ViewChild('search', { static: false })
  public searchElementRef: ElementRef;
  location: Location;
  latitude: number;
  longitude: number;
  zoom: number;
  address: string;
  dataMap: any;
  baseposition: any;
  linkposition: any;
  heading: any;
  pitch: any;
  vof: any;
  streetForm: FormGroup;
  panorama: google.maps.StreetViewPanorama;
  addressMap = false;
  zero_results = false;


  constructor( hpService: HpService, chgDetectorRef: ChangeDetectorRef, router:Router, 
    public alertService: AlertService,
     public dialog: MatDialog,
   public dialogRef: MatDialogRef<StreetViewMapComponent>,
     public dialogVueMaisonRef: MatDialogRef<vueMaisonComponent>,    
    public fb: FormBuilder,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) { 
    
      super(chgDetectorRef, hpService, router);

    }

  ngOnInit() {
      super.ngOnInit();
    this.initAutocomplete();
    this.location = {
      latitude: -28.68352,
      longitude: -147.20785,
      mapType: "satelite"

    }
    this.streetForm = this.fb.group({
      adresse: ['', [Validators.required]]

    });
  }

  getValidator() {
    return this.streetForm.invalid;
  }
  /*
  Auto complete
  */

  initAutocomplete() {
     let panorama = new google.maps.StreetViewPanorama(
      document.getElementById('street-view'),
      { 
        position: { lat: this.getHpService().getConfig().data_googleMap.lat,  lng: this.getHpService().getConfig().data_googleMap.lng},
        zoom: 0,

        pov: {
          "heading": this.getHpService().getConfig().data_googleMap.heading,
          "pitch": this.getHpService().getConfig().data_googleMap.pitch,
        },
        visible: true,
      });
    let geocoder = new google.maps.Geocoder();

    const input = document.getElementById("pac-input") as HTMLInputElement;
    const btnMap = document.getElementById("bt_stview_screen") as HTMLInputElement;

    const errorMap = document.getElementById("errorMap") as HTMLInputElement;
    const options = {
      fields: ["formatted_address", "geometry", "name"],
      strictBounds: false,
      types: ["establishment"],
    };

    let autocomplete = new google.maps.places.Autocomplete(input);
    autocomplete.bindTo('bounds', panorama);
    const searchBox = new google.maps.places.SearchBox(input);

    panorama.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
    /*Add listner to input search
    */
    autocomplete.addListener('place_changed', function () {
      let place = autocomplete.getPlace();
      if (!place.geometry) {
        //window.alert("Autocomplete's returned place contains no geometry");
        errorMap.style.display = "block";
        return;
      }
      else {
        errorMap.style.display = "none";

      }
    });

    searchBox.addListener("places_changed", () => {
      const places = searchBox.getPlaces();


      if (places.length == 0) {

        return;
      };
      geocoder.geocode({
        'address': input.value
      }, function (results, status) {


        if (status == 'OK') {
          panorama.setPosition(results[0].geometry.location);
          // errorMap.style.display = "none";



        } else {
          alert('Geocode was not successful for the following reason: ' + status);

        }
      });

    });


    panorama.addListener("position_changed", () => {
      const errorMap = document.getElementById("errorMap") as HTMLInputElement;
      this.linkposition = panorama.getPosition() + "";
      this.linkposition = this.linkposition.slice(1, -1);
      console.log("-----------Link----------->>" + this.linkposition);


    });
    panorama.addListener("pov_changed", () => {
      const errorMap = document.getElementById("errorMap") as HTMLInputElement;
      this.heading = panorama.getPov().heading + ""
      console.log("-----------Heading----------->>" + this.heading);
      this.pitch = panorama.getPov().pitch + "";
      console.log("-----------Pitch----------->>" + this.pitch);
      this.vof = Math.round(180 / Math.pow(2, panorama.getZoom()));
      this.alertService.googleMapError(this.linkposition, this.heading, this.vof, this.pitch).subscribe(
        data => {
          if (data.status !== "ZERO_RESULTS") {
            this.zero_results = true;
            
            //errorMap.style.display = "none";
          }
          else {
            this.zero_results = false;
            //errorMap.style.display = "block";
          }

        },
        error => {
          this.alertService.error(error);

        });


    });


  }

  setMapImage() {
    console.log("https://maps.googleapis.com/maps/api/streetview?size=640x360&location=" + this.linkposition + "&heading=" + this.heading + "&fov=" + this.vof + "&pitch=" + this.pitch )
  }

  screentShhot() {
    html2canvas(document.querySelector("#street-view")).then(canvas => {

      document.body.appendChild(canvas);
      var base64 = canvas.toDataURL();

    });
  }


  closeDialog() {
    const errorMap = document.getElementById("errorMap") as HTMLInputElement;
    if (this.streetForm.invalid) {
      return;
    }

    this.dataMap = {
      "visible": 1,
      "linkposition": this.linkposition,
      "heading": this.heading,
      "pitch": this.pitch,
      "fov": this.vof
    }


    this.alertService.googleMapError(this.linkposition, this.heading, this.vof, this.pitch).subscribe(
      data => {
        if (data.status !== "ZERO_RESULTS") {
           this.getHpService().setDataMap(this.dataMap);
          this.dialogRef.close({ event: 'close', data: this.dataMap });
          this.zero_results = true;
          errorMap.style.display = "none";
          this.getHpService().setTypeVisuel("googleMap");
          this.getHpService().emitDataChange();
        }
        else {
          // const errorMap = document.getElementById("errorMap") as HTMLInputElement;
          this.zero_results = false;
          errorMap.style.display = "block";
        }

      },
      error => {
        this.alertService.error(error);
        console.log(">>>>>>>>>>>>>>>>>>>>>>>>>> Error");
      });
  }

  closeWithouEmit() {

    this.dataMap = this.getHpService().getConfig().data_googleMap;
    let data = { "type": "no" }
    switch(this.getHpService().getTypeVisuel('0'))
    {
      case "upload-0" :
        this.getHpService().setTypeVisuel("upload-0");
        break;
      case "googleMap" :
          this.getHpService().setTypeVisuel("googleMap");
          break;  
      default :
      this.getHpService().setTypeVisuel("view-0");
      this.getHpService().setImageName(this.getHpService().getImageName('0'));
      this.getHpService().setImageName(this.getHpService().getImageName('1')); 
            
    }
  
    this.getHpService().emitDataChange();
    this.dialogRef.close({ event: 'close', data: data });

  }

  openDialog(demande: string) {
    const dialogRef = this.dialog.open(SignConfirmComponent, {
      panelClass: 'full-width-dialog-error-mssage',
      data: { name: demande }
    });
    dialogRef.afterClosed().subscribe(result => {
    });

  }
}
